import * as React from 'react'
import { statusType } from '../Search/hooks/useGetSearchResults'
import { SearchListItem, SearchResponse } from '@user/store/search/typings'
import { SearchResultsContent } from './SearchResultsContent'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { UseDeleteRecentSearches } from '@user/store/globalSearch/hooks/useDeleteRecentSearches'
import { OnSearchAddressClick } from '../ResultItem/typings'
import { Theme } from '@mui/material/styles'

export type Props = {
  onLocationClick: () => void
  onRowClick: (searchItem: any) => void
  searchStatus: statusType
  searchData?: SearchResponse
  recentSearchData: SearchListItem[]
  searchText: string
  onSearchAddressClick?: OnSearchAddressClick
}

export function SearchResults(props: Props) {
  const clearRecentSearch = UseDeleteRecentSearches()
  const {
    onLocationClick,
    onRowClick,
    searchStatus,
    searchData,
    searchText,
    recentSearchData,
    onSearchAddressClick,
  } = props
  return (
    <Stack aria-label="search results" direction="column">
      {searchStatus !== 'idle' && (
        <Divider
          sx={{
            marginLeft: (theme: Theme) => theme.spacing(-2),
            marginRight: (theme: Theme) => theme.spacing(-2),
            marginTop: 'auto',
          }}
        />
      )}
      {recentSearchData.length > 0 && searchText?.length < 3 && (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ marginTop: (theme: Theme) => theme.spacing(0.8) }}
        >
          <Typography variant={'subtitle2'}>Recent</Typography>
          <Button
            sx={{
              color: (theme: Theme) => theme.palette.primary.main,
              padding: (theme: Theme) =>
                `${theme.spacing(0.5)} ${theme.spacing(0.5)}`,
              minWidth: '40px',
            }}
            data-test-id="clearRecentSearchesBtn"
            onClick={clearRecentSearch}
          >
            Clear
          </Button>
        </Box>
      )}
      <SearchResultsContent
        onLocationClick={onLocationClick}
        onRowClick={onRowClick}
        searchStatus={searchStatus}
        searchData={searchData}
        recentSearchData={recentSearchData}
        searchText={searchText}
        onSearchAddressClick={onSearchAddressClick}
      />
    </Stack>
  )
}
